/**
 * Pixel Diff layers
 * See https://openlayers.org/en/latest/examples/raster.html for an example
 */
import ImageLayer from '@planet/maps/layer/Image';
import OLXYZSource from 'ol/source/XYZ';
import RasterSource from '@planet/maps/source/Raster';
import React, {useEffect, useRef} from 'react';
import {array, bool, func} from 'prop-types';

// https://en.wikipedia.org/wiki/Relative_luminance
const luminance = (r, g, b) => {
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};

const rasterOp = (pixels, data) => {
  const luminance = (r, g, b) => {
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
  };

  if (pixels[0][3] === 0 || pixels[1][3] === 0) {
    return data.NODATA_COLOR;
  }

  const r0 = pixels[0][0] / 255;
  const g0 = pixels[0][1] / 255;
  const b0 = pixels[0][2] / 255;
  const r1 = pixels[1][0] / 255;
  const g1 = pixels[1][1] / 255;
  const b1 = pixels[1][2] / 255;
  const diff = luminance(r0, g0, b0) - luminance(r1, g1, b1);

  return diff < data.range[0] || diff > data.range[1]
    ? data.NODATA_COLOR
    : data.DATA_COLOR;
};

const CompareRasters = ({
  urls = [],
  visible,
  rangeValues,
  onPrerender,
  onPostrender,
}) => {
  const rasterSourceRef = useRef();

  const onBeforeOperations = event => {
    event.data.range = rangeValues;
    event.data.DATA_COLOR = [255, 0, 0, 255];
    event.data.NODATA_COLOR = [0, 0, 0, 0];
  };

  useEffect(() => {
    rasterSourceRef.current?.refresh();
  }, [rangeValues]);

  if (!urls.length) {
    return false;
  }

  return (
    <ImageLayer
      visible={visible}
      onPostrender={onPostrender}
      onPrerender={onPrerender}
    >
      <RasterSource
        ref={rasterSourceRef}
        options={{
          sources: urls.map(
            url =>
              new OLXYZSource({
                url: url,
                crossOrigin: 'anonymous',
                transition: 0,
              })
          ),
          lib: {
            luminance,
          },
          operation: rasterOp,
        }}
        onBeforeOperations={onBeforeOperations}
      />
    </ImageLayer>
  );
};

CompareRasters.propTypes = {
  urls: array.isRequired,
  visible: bool,
  onPrerender: func,
  onPostrender: func,
  rangeValues: array,
};

export default CompareRasters;
